import React from "react";
import "./footer.css"

const Footer = () => {
   return (
      <footer className="footer">
         <div className="footer__container container">
            <h1 className="footer__title">Stuart Daniells</h1>

            <ul className="footer__list">
               <li>
                  <a href="#about" className="footer__link">About</a>
               </li>

               <li>
                  <a href="#services" className="footer__link">Projects</a>
               </li>

               <li>
                  <a href="#services" className="footer__link">Portfolio</a>
               </li>
            </ul>

            <div className="footer__social">
               <a href="https://www.linkedin.com/in/stuart-daniells/" className="footer__social-link" target="_blank" rel="noreferrer">
               <i className="bx bxl-linkedin"></i>
               </a>
               <a href="https://github.com/StuartDaniells" className="footer__social-link" target="_blank" rel="noreferrer">
                  <i className="bx bxl-github"></i>
               </a>
               <a href="https://twitter.com/DaniellsStuart" className="footer__social-link" target="_blank" rel="noreferrer">
                  <i className="bx bxl-twitter"></i>
               </a>
            </div>

            <span className="footer__copy">&#169; Stuart Daniells. All rights reserved.</span>
         </div>
      </footer>
   )
}

export default Footer;